import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_APPLICATIONS,
  DELETE_APPLICATION,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import EnhancedTableStatusCell from "@vocollege/components/dist/EnhancedTable/components/EnhancedTableStatusCell";
import { getContactName } from "@vocollege/app/dist/modules/VoHelpers";

export default function Applications() {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/content/applications/${id}`);
  };

  const renderResponsibleColumn = (data: any) => {
    return data && data.responsible ? getContactName(data.responsible) : "-";
  };

  const renderCategoryColumn = (data: any) => {
    return I18n.get.application.categories[data.category];
  };

  return (
    <Layout>
      <EnhancedTable
        className="vo-global__top-bottom-space"
        title={I18n.get.application.labels.applications}
        operations={{
          category: "applications",
          get: GET_APPLICATIONS,
          delete: DELETE_APPLICATION,
        }}
        labels={{
          deleted: I18n.get.application.messages.applicationDeleted,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.user.labels.email, field: "email" },
          {
            title: I18n.get.form.labels.responsible,
            field: "responsible",
            render: renderResponsibleColumn,
          },
          {
            title: I18n.get.form.labels.category,
            field: "category",
            render: renderCategoryColumn,
          },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
          {
            title: I18n.get.form.labels.status,
            field: "status",
            width: 120,
            render: (data: any) => (
              <EnhancedTableStatusCell data={data.status} />
            ),
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
      ></EnhancedTable>
    </Layout>
  );
}
